var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm._f("trans")(_vm.placeholder)))]),_vm._v(" "),_c('v-select',{attrs:{"searchable":false,"options":_vm.options,"onChange":_vm.selected,"label":_vm.label},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_vm._v("\n            "+_vm._s(option.label)+"\n        ")]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8190678","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Options.vue
// module id = null
// module chunks = 